"use strict";

exports.__esModule = true;
exports.RealtimeChart = RealtimeChart;
var _react = _interopRequireDefault(require("react"));
var _SlidingInterval = require("../../Timeline/SlidingInterval");
var _ComboChart = require("../ComboChart");
var _SlidingTimeline = require("../../Timeline/SlidingTimeline");
var _scales = require("../scales");
var _excluded = ["width", "height", "frequency", "duration", "latestValues", "series", "referenceLineValue", "showReferenceLine", "padding", "xAxisHeight", "yAxisWidth", "showXAxis", "showYAxis"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getXValue = function getXValue(item) {
  return item.interval.startMillis;
};
var getYValue = function getYValue(item) {
  return item.value;
};
function RealtimeChart(props) {
  var width = props.width,
    height = props.height,
    _props$frequency = props.frequency,
    frequency = _props$frequency === void 0 ? 200 : _props$frequency,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 60000 : _props$duration,
    latestValues = props.latestValues,
    series = props.series,
    referenceLineValue = props.referenceLineValue,
    showReferenceLine = props.showReferenceLine,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? 4 : _props$padding,
    _props$xAxisHeight = props.xAxisHeight,
    xAxisHeight = _props$xAxisHeight === void 0 ? 30 : _props$xAxisHeight,
    _props$yAxisWidth = props.yAxisWidth,
    yAxisWidth = _props$yAxisWidth === void 0 ? 30 : _props$yAxisWidth,
    _props$showXAxis = props.showXAxis,
    showXAxis = _props$showXAxis === void 0 ? true : _props$showXAxis,
    _props$showYAxis = props.showYAxis,
    showYAxis = _props$showYAxis === void 0 ? true : _props$showYAxis,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_SlidingInterval.SlidingInterval, {
    duration: duration,
    frequency: frequency
  }, function (interval) {
    return /*#__PURE__*/_react["default"].createElement(_SlidingTimeline.SlidingTimeline, {
      interval: interval,
      latestValues: latestValues
    }, function (timelines) {
      return /*#__PURE__*/_react["default"].createElement(_ComboChart.ComboChart, _extends({
        width: width,
        height: height
        // eslint-disable-next-line no-unused-vars
        ,
        createXScale: function createXScale(from, to, data) {
          return (0, _scales.createIntervalScale)(from, to, interval);
        },
        series: series.map(function (item, index) {
          return Object.assign({
            getXValue: getXValue,
            getYValue: getYValue,
            data: timelines[index].filter(function (timeline) {
              return !isNaN(timeline.value);
            })
          }, item);
        }),
        referenceLineValue: referenceLineValue,
        showReferenceLine: showReferenceLine,
        padding: padding,
        xAxisHeight: xAxisHeight,
        yAxisWidth: yAxisWidth,
        showXAxis: showXAxis,
        showYAxis: showYAxis
      }, extra));
    });
  });
}